




































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import { getDefaultAloGroupCarac } from '@/models/alo/AloGroupCarac';

@Component({
  name: 'GroupCarac',  
})
export default class GroupCarac extends Vue {
  private loading = false
  private showError = false  
  private showNew = false
  private newGroupCarac = getDefaultAloGroupCarac()
  
  private toolbarHeight = 50

  private get tableauHeight() {    
    return this.$store.myGetters.contentHeight - this.toolbarHeight - 25
  }

  onResize(){
    //@ts-ignore
    this.toolbarHeight = this.$refs.toolbar.$el.clientHeight
  }

  private get groupCaracList() {
    return this.$store.myGetters.groupCaracList
  }

  private get search(){
    return this.$store.myGetters.searchGroupCarac
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_GROUP_CARAC(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortGroupCaracDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_GROUP_CARAC_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortGroupCaracBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_GROUP_CARAC_BY(value)
  }

  private get flux(){
    return this.$store.myGetters.flux
  }

  private headers = [
    { text: 'ID', value: 'id', width:"80" },
    { text: 'Nom du groupe', value: 'libelle' }/*,
    { text: 'Marques exclues', value: 'nbMarque' },
    { text: 'Codics  exclus', value: 'nbCodic' },
    { text: 'Flux associés (ids)', value: 'flxIds' }*/
  ]

  created() {
    this.loading = true    
    this.$store.myActions.ADM_GROUP_CARAC_REQUEST().finally(() => {
      this.loading = false
    })
  }

  openDetail(item: any) {
    this.$router.push({name:'ModifyGroupCarac',params:{groupCaracId:item.id}})
  }

  addGroupCarac() {
    this.showNew = true  
    this.newGroupCarac = {...getDefaultAloGroupCarac()}
  }

  save(){
    this.$store.myActions.ADM_GROUP_CARAC_SAVE_REQUEST(this.newGroupCarac).then((groupCarac)=>{
      this.showNew = false
      this.openDetail(groupCarac)
    })    
  }
  
}
